import { ITableColumn } from '@components/common/UTable/UTable';

import { TransformedDictionaries } from '@/api/dictionaries/types';
import { ControlInfo } from '@/pages/Vaccination/components/control/types';
import {
  GEOLOCATION_ERROR,
  GEOLOCATION_ERROR_LABELS,
  GEOLOCATION_UNDEFINED_LABEL,
  individualVaccinationStatus,
} from '@/shared/vaccination/enums';

/**
 * Соответствие геолокации: null без причины — особь ещё не отмечена,
 * null с причиной — местоположение контролера не определено.
 */
const getGeolocationComplianceText = (
  isNearDivision: boolean | null,
  geolocationError: GEOLOCATION_ERROR | null | undefined,
) => {
  if (isNearDivision === true) return 'Соответствует';
  if (isNearDivision === false) return 'Не соответствует';
  if (geolocationError) {
    return `${GEOLOCATION_UNDEFINED_LABEL} (${GEOLOCATION_ERROR_LABELS[geolocationError] ?? geolocationError})`;
  }
  return '';
};

export const columns = (dictMap: TransformedDictionaries | undefined) =>
  [
    {
      title: '№ п/п',
      dataIndex: 'index',
      width: 50,
    },
    {
      title: 'Инвентарный номер',
      dataIndex: 'inventoryNumber',
    },
    {
      title: 'Объект',
      dataIndex: 'individualLocationId',
      render: (value: string) => dictMap?.INDIVIDUAL_LOCATION?.[value]?.name || '',
    },
    {
      title: 'Геолокация',
      dataIndex: 'isNearDivision',
      render: (value: boolean | null, record: ControlInfo) =>
        getGeolocationComplianceText(value, record.geolocationError),
    },
    {
      title: 'Состояние вакцинации',
      dataIndex: 'status',
      render: (value: keyof typeof individualVaccinationStatus) =>
        individualVaccinationStatus[value],
    },
  ] as ITableColumn[];
